/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartCheckoutOfferButton_transaction$ref = any;
export type CartCheckoutOfferButton_transaction = {
    readonly hasDealerSubmittedOfferAction: boolean | null;
    readonly hasAcceptedBuyerOfferAction: boolean | null;
    readonly " $refType": CartCheckoutOfferButton_transaction$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartCheckoutOfferButton_transaction",
    "type": "Transaction",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "hasDealerSubmittedOfferAction",
            "name": "hasAction",
            "args": [
                {
                    "kind": "Literal",
                    "name": "actionCode",
                    "value": "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER"
                }
            ],
            "storageKey": "hasAction(actionCode:\"BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER\")"
        },
        {
            "kind": "ScalarField",
            "alias": "hasAcceptedBuyerOfferAction",
            "name": "hasAction",
            "args": [
                {
                    "kind": "Literal",
                    "name": "actionCode",
                    "value": "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER"
                }
            ],
            "storageKey": "hasAction(actionCode:\"BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER\")"
        }
    ]
} as any);
(node as any).hash = '5247088894c395c645274a37c5ba5b48';
export default node;
